import {
  formatServiceTimeAbsolute,
  formatServiceTimeFriendlyLabel,
} from '@/utils/formatServiceTime';

interface FormattedServiceTimeProps {
  value: string;
  className?: string;
}

/** Renders absolute service date plus friendly label when available (e.g. Today). */
export default function FormattedServiceTime({ value, className }: FormattedServiceTimeProps) {
  const absolute = formatServiceTimeAbsolute(value);
  const friendly = formatServiceTimeFriendlyLabel(value);

  return (
    <span className={className}>
      <span>{absolute}</span>
      {friendly ? (
        <span className="text-green-600 font-semibold"> · {friendly}</span>
      ) : null}
    </span>
  );
}
